import { render, staticRenderFns } from "./SelectedItem.vue?vue&type=template&id=74003420&scoped=true"
import script from "./SelectedItem.vue?vue&type=script&lang=js"
export * from "./SelectedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74003420",
  null
  
)

export default component.exports